import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { api, saveAdminToken } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // If already authenticated, skip login
  const existing = localStorage.getItem("admin_token");
  if (existing) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      saveAdminToken(data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
          "Não foi possível entrar. Verifique seus dados."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-[#0B1E36] text-white flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-[#C5A059] mb-6">
            <Lock size={16} strokeWidth={1.5} />
            <span className="text-[0.7rem] uppercase tracking-[0.3em]">
              Painel restrito
            </span>
          </div>
          <h1 className="font-serif-display text-4xl md:text-5xl leading-[1.05] tracking-[-0.02em]">
            Painel <span className="italic text-[#C5A059]">Carlos Medeiros</span>
          </h1>
          <p className="mt-4 text-white/60 text-sm leading-relaxed">
            Acesso exclusivo à administração de sermões, livros e conteúdo.
          </p>
        </div>

        <form
          onSubmit={submit}
          className="bg-white/[0.04] border border-white/10 p-8 space-y-6"
          data-testid="admin-login-form"
        >
          <div>
            <label className="text-[0.7rem] uppercase tracking-[0.22em] text-white/60">
              E-mail
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="mt-2 w-full bg-transparent border-b border-white/20 py-3 outline-none focus:border-[#C5A059] transition-colors"
              placeholder="seu@email.com"
              required
            />
          </div>
          <div>
            <label className="text-[0.7rem] uppercase tracking-[0.22em] text-white/60">
              Senha
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="mt-2 w-full bg-transparent border-b border-white/20 py-3 outline-none focus:border-[#C5A059] transition-colors"
              placeholder="••••••••"
              required
            />
          </div>

          {error && (
            <div
              data-testid="admin-login-error"
              className="text-sm text-rose-300 bg-rose-900/20 border border-rose-800/40 px-4 py-3"
            >
              {typeof error === "string" ? error : "Erro de autenticação."}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#C5A059] hover:bg-[#B58F4A] text-[#0B1E36] py-4 text-xs uppercase tracking-[0.28em] font-medium inline-flex items-center justify-center gap-2 transition-colors disabled:opacity-60"
          >
            {loading ? (
              <>
                <Loader2 size={14} className="animate-spin" /> Entrando…
              </>
            ) : (
              "Entrar"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
